// Copyright 2023 Amazon.com, Inc. or its affiliates. All Rights Reserved.
export enum LandingPageState {
    BANNER_ONLY,
    FULL_PAGE,
}
